import React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

const BreadcrumbComponent = ({ items }) => {
    return (
        <Breadcrumb
            separator=">"
            items={items.map((item) => ({
                title: item.url ? (
                    <Link to={item.url}>{item.name}</Link>
                ) : (
                    <span>{item.name}</span>
                ),
            }))}
        />
    );
};

export default BreadcrumbComponent;